import React from 'react';
import { Palette, Brain, AppWindow, Sparkles, Zap, MessageSquare, ExternalLink } from 'lucide-react';

export default function GeneralSettings() {
  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-bold text-white mb-2">User manual</h2>
        <p className="text-gray-400">Discover how to set up and optimize your chatbot</p>
      </div>

      {/* Section Design */}
      <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-8 border border-white/10 hover:border-indigo-500/50 transition-all group">
        <div className="flex items-start gap-6">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-indigo-500/20 to-purple-500/20 flex items-center justify-center">
            <Palette className="w-6 h-6 text-indigo-400" />
          </div>
          <div className="flex-1">
            <h3 className="text-xl font-semibold text-white mb-4">Design customization</h3>
            <div className="space-y-4 text-gray-300">
              <p>Create a unique experience with our customization tools :</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Choose your colors and gradients</li>
                <li>Customize the texts and messages</li>
                <li>Add your logo and icons</li>
                <li>Set up the light or dark theme</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Section IA */}
      <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-8 border border-white/10 hover:border-purple-500/50 transition-all group">
        <div className="flex items-start gap-6">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-500/20 to-pink-500/20 flex items-center justify-center">
            <Brain className="w-6 h-6 text-purple-400" />
          </div>
          <div className="flex-1">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-semibold text-white">Artificial Intelligence</h3>
              <a 
                href="https://prompt.botmaker-agency.ai" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-4 py-2 bg-indigo-500/20 text-indigo-400 rounded-lg hover:bg-indigo-500/30 transition-colors"
              >
                Access to our prompt generator
                <ExternalLink className="w-4 h-4" />
              </a>
            </div>
            <div className="space-y-4 text-gray-300">
              <p>Set up the AI for natural and relevant conversations :</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Define your assistant's personality</li>
                <li>Add your knowledge base</li>
                <li>Set up the conversation goals</li>
                <li>Optimize responses with the OpenAI API</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Section Mini Apps */}
      <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-8 border border-white/10 hover:border-pink-500/50 transition-all group">
        <div className="flex items-start gap-6">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-pink-500/20 to-red-500/20 flex items-center justify-center">
            <AppWindow className="w-6 h-6 text-pink-400" />
          </div>
          <div className="flex-1">
            <h3 className="text-xl font-semibold text-white mb-4">Mini Applications</h3>
            <div className="space-y-4 text-gray-300">
              <p>Enhance your chatbot with advanced features :</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Integrate an appointment calendar</li>
                <li>Showcase your products and services</li>
                <li>PShowcase your products and services</li>
                <li>Customize each mini-app according to your needs</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Fonctionnalités clés */}
      <div className="grid grid-cols-3 gap-6">
        <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10 hover:border-indigo-500/50 transition-all group">
          <Sparkles className="w-8 h-8 text-indigo-400 mb-4" />
          <h4 className="text-lg font-semibold text-white mb-2">Smart responses</h4>
          <p className="text-gray-400">Contextual and personalized responses with advanced AI</p>
        </div>

        <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10 hover:border-purple-500/50 transition-all group">
          <Zap className="w-8 h-8 text-purple-400 mb-4" />
          <h4 className="text-lg font-semibold text-white mb-2">CRM integrations</h4>
          <p className="text-gray-400">Automatic synchronization with your existing tools</p>
        </div>

        <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10 hover:border-pink-500/50 transition-all group">
          <MessageSquare className="w-8 h-8 text-pink-400 mb-4" />
          <h4 className="text-lg font-semibold text-white mb-2">Lead generation</h4>
          <p className="text-gray-400">Automatic detection and management of customer contacts</p>
        </div>
      </div>
    </div>
  );
}